import React, { useEffect, useRef, useState } from 'react';
import './PicksSection.css';
import axios from 'axios';
import { Link } from 'react-router-dom';

const PicksSection = () => {
  const [curatedPicks, setCuratedPicks] = useState([]);
  const headerRef = useRef(null);
  const cardRefs = useRef([]);

  
      useEffect(() => {
          const fetchData = async () => {
              const response = await axios.post("https://cyberathon.com/multivendor/index.php/Api/Master_controller/getCuratedPicks");
              const filteredData = response.data.data.slice(1, 7);
              setCuratedPicks(filteredData);
          }
          fetchData();
      }, [])

  useEffect(() => {
      if (!curatedPicks.length) return;
    
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("animate-in");
            }
          });
        },
        { threshold: 0.1 }
      );
    
      if (headerRef.current) observer.observe(headerRef.current);
    
      cardRefs.current.forEach((el) => {
        if (el) observer.observe(el);
      });
    
      return () => observer.disconnect();
    }, [curatedPicks]);

  return (
    <section className="curated-section">
      <div className="container-pick">
        <div className="section-header" ref={headerRef}>
          <h2>Curated Picks</h2>
          <div className="title-line"></div>
          <p>Handpicked style essentials tailored for your lifestyle.</p>
        </div>

        <div className="curated-grid">
          {curatedPicks.map((pick, index) => (
            <div
              key={pick.id}
              className="curated-card"
              ref={(el) => (cardRefs.current[index] = el)}
              style={{ '--delay': `${index * 100}ms` }}
            >
              <img src={`https://cyberathon.com/multivendor/${pick.image}`} alt={pick.title} />
              <div className="card-overlay">
                <span>{pick.tag}</span>
                <h3>{pick.heading}</h3>
                <Link
  to={`/products?category=${pick.category_id}&subcategory=${pick.subcategory_id}`}
  className="shop-now"
>
         <button className="Addto-cart">
          Shop Now →
        </button>
        </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PicksSection;